module.exports = __webpack_public_path__ + "img/3.26cad09e.png";